import type Controller from '@ember/controller';
import type Transition from '@ember/routing/transition';
import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';

export default abstract class SidebarBookingRequestsSummaryRoute extends PermittedRoute {
  permission = 'calendar.booking-requests.summary';

  abstract parentRoute: string;

  model() {
    return this.modelFor(this.parentRoute);
  }

  setupController(controller: Controller, model, transition: Transition): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, { bookingRequest: model });
  }
}
